import React, { useEffect, useState } from "react"
import { Link, NavLink, useLocation } from "react-router-dom"
import LF50Logo from "../images/Lowfye_Logo_full_name_blue.png"
import "./Nav.css"

const NAV_ITEMS = [
    { to: "/music", label: "MUSIC" },
    { to: "/tour", label: "TOUR" },
    { to: "/store", label: "MERCH" },
]

export const NavBar = () => {
    const { pathname } = useLocation()
    const [menuOpen, setMenuOpen] = useState(false)

    // close the mobile menu whenever the route changes
    useEffect(() => setMenuOpen(false), [pathname])

    const overHero = pathname === "/"

    return (
        <nav className={`lf-nav ${overHero ? "lf-nav--overlay" : ""} ${menuOpen ? "lf-nav--open" : ""}`}>
            <div className="lf-nav__inner">
                <Link to="/" className="lf-nav__brand">
                    <img src={LF50Logo} alt="Lowfye50 home" />
                </Link>

                <ul className="lf-nav__links">
                    {NAV_ITEMS.map(item => (
                        <li key={item.to}>
                            <NavLink to={item.to} className={({ isActive }) => isActive ? "active" : ""}>
                                {item.label}
                            </NavLink>
                        </li>
                    ))}
                </ul>

                <button
                    className="lf-nav__toggle"
                    aria-label={menuOpen ? "Close menu" : "Open menu"}
                    aria-expanded={menuOpen}
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <i className={menuOpen ? "fas fa-times" : "fas fa-bars"}></i>
                </button>
            </div>
        </nav>
    )
}
